package gr.tech.GRAttestation.models.user

/*
    Roles are stored as bitwise inside the PSQL Tables,
    however once passed and returned to frontend, they should be in list String format.

    - Makes it more clear on frontend, what is needing to access what.
    - Less confusion on roles being thrown around
*/

enum class USER_ROLES(val bit: Short, val role: String) {
    NEW_USER(1, "NEW_USER"),
    CONFIRMED_USER(2, "CONFIRMED_USER"),
    MODERATOR(8, "MODERATOR"),
    ADMIN(16, "ADMIN");
    
    companion object {
        /*
            Parse and send roles as string back to frontend.
        */
        fun parseUserRoleBitwise(roleBitwise: Short): List<String> {
            val types = mutableListOf<String>()

            entries.forEach { role ->
                if ((roleBitwise.toInt() and role.bit.toInt()) != 0) {
                    types.add(role.role)
                }
            }

            return types
        }
    }
}